import React, { useEffect, useMemo, useState } from 'react'
import './appointment-filter.scss'
import filter from "../../assets/images/filter.png"
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faArrowsRotate, faFilter } from '@fortawesome/free-solid-svg-icons';
import CreatableSearchSelect from '../common/updated-input/createble-search-select/creatable-search-select';
import { getLocations, resetLocations } from '../../store/slices/locationSlice';
import { useDispatch, useSelector } from 'react-redux';
import SelectWithLocalSearch from '../common/updated-input/select-with-local-search/select-with-local-search';
import { useSearchParams } from 'react-router-dom';
import { LocalStorageService } from '../../utils/local-storage';
import { DateRange } from "react-date-range";

const STATUS_OPTIONS = [
    { value: "present", label: "Present" },
    { value: "pending", label: "Pending" },
    { value: "completed", label: "Completed" },
    { value: "canceled", label: "Canceled" },
];

const AppointmentFilter = ({ locationDoctorFilterFun, filterStatusFun, setStatus, status, width, currentDate, filterDateFun, setFilterDate, filterDate }) => {
    // const utcDate = new Date();
    // let bdDate = utcDate.toLocaleDateString('en-US', { timeZone: 'Asia/Dhaka' });
    // bdDate = bdDate.split('/')
    // let date = `${bdDate[2]}-${bdDate[0].length == 1 ? ("0" + bdDate[0]) : bdDate[0]}-${bdDate[1]?.length == 1 ? ("0" + bdDate[1]) : bdDate[1]}`
    let [filterLocalData] = useState(LocalStorageService.get("appointmentFilter"))


    const [selectedLocation, setSelectedLocation] = useState({})
    const [locationRest, setLocationRest] = useState(false)
    let { isLoading, allLocations, noLocationFound, locationOptions } = useSelector(
        (state) => state.location
    );
    const [searchParams] = useSearchParams();
    const dispatch = useDispatch();
    const [currentLocation, setCurrentLocation] = useState('')
    const [currentDoctor, setCurrentDoctor] = useState('')

    const [dateRange, setDateRange] = useState([
        {
            startDate: new Date(filterDate?.startDate),
            endDate: new Date(filterDate?.endDate),
            key: "selection",
        },
    ]);

    // useEffect(() => {
    //     dispatch(getLocations({}));
    // }, []);

    // const handleSubmitLocation = (option) => {
    //     setSelectedLocation(option)
    //     locationDoctorFilterFun('location', option)
    //     setCurrentLocation('')
    // }

    // const handleLocationDoctor = (option) => {
    //     setCurrentDoctor("")
    //     locationDoctorFilterFun('doctor', option)
    // }


    // const locationDoctorRestFun = () => {
    //     locationDoctorFilterFun('reset', '')
    //     setSelectedLocation({})
    //     setCurrentLocation("")
    //     setCurrentDoctor("")
    //     setLocationRest(true)
    // }

    function formatDate(date) {
        const inputDate = new Date(date);
        const year = inputDate.getFullYear();
        const month = String(inputDate.getMonth() + 1).padStart(2, '0');
        const day = String(inputDate.getDate()).padStart(2, '0');
        return `${year}-${month}-${day}`;
    }

    const handleStatusClick = (val) => {
        if (status === val) {
            setStatus("");
            filterStatusFun("reSet");
        } else {
            setStatus(val);
            filterStatusFun(val);
        }
    };

    const clearStatusFilter = () => {
        setStatus("");
        filterStatusFun("reSet");
    };

    const dateFilter = (ranges) => {
        setDateRange([ranges.selection])
        const startDate = ranges.selection?.startDate || ""
        const endDate = ranges.selection?.endDate || ""
        filterDateFun('between-date', formatDate(startDate), formatDate(endDate))
    }

    useMemo(() => {

        if (searchParams.get('location') || filterLocalData?.locationId) {

            allLocations?.map((location) => {
                if ((searchParams.get('location') || filterLocalData?.locationId) == location?._id) {
                    setCurrentLocation(location?.name)

                }
            })
        }
        if (searchParams.get('doctor') || filterLocalData?.locationId) {
            allLocations?.map((location) => {
                if ((searchParams.get('location') || filterLocalData?.locationId) == (location?._id)) {
                    setSelectedLocation(location)
                    location?.doctors?.map((doctor) => {
                        if ((searchParams.get('doctor') || filterLocalData?.doctorId) == doctor?._id) {
                            setCurrentDoctor(doctor?.name)

                        }
                    })

                }
            })
        }
    }, [searchParams.get('location'), searchParams.get('doctor'), allLocations, filterLocalData?.locationId])


    return (
        <div className='filter-section' style={{ width: width }}>
            {/* <p className='text-center heading m-0'><img className='mr-1' src={filter}></img> Filters</p> */}
            {/* <hr className='p-0 m-0 mb'></hr> */}

            <div className='date-filter border'>
                <div className=''>
                    <DateRange
                        ranges={dateRange}
                        onChange={(ranges) => dateFilter(ranges)}
                        moveRangeOnFirstSelection={false}
                        rangeColors={["#17A980"]}
                    />
                </div>
                {/* <p className='p-0 m-0 title text-center'>Filter  <FontAwesomeIcon onClick={() => {
                    filterDateFun('current-date', date?.slice(0, 10), endDate)
                    setCurrentLocation("")
                    setCurrentDoctor("")
                }} size='xs' className='ml-1 rest' icon={faArrowsRotate} /></p>
                <hr className='m-0 p-0 mb-2'></hr> */}
                {/* <div onClick={() => {
                    if (((filterDate?.startDate?.slice(0, 10) != date?.slice(0, 10)) || (filterDate?.endDate?.slice(0, 10) != date?.slice(0, 10))))
                        filterDateFun('current-date', date?.slice(0, 10), date?.slice(0, 10))
                }}>
                    <input checked={((filterDate?.startDate?.slice(0, 10) == date?.slice(0, 10)) && (filterDate?.endDate?.slice(0, 10) == date?.slice(0, 10))) ? true : false} id='today' name="today" type='checkbox'></input>
                    <label htmlFor='today'>Todays Appointment</label>
                </div> */}

            </div>
            <div className="appointment-filter-status px-2 py-2 date-filter border">
                <div className="appointment-filter-status__head">
                    <div className="appointment-filter-status__head-title">
                        <span className="appointment-filter-status__icon" aria-hidden="true">
                            <FontAwesomeIcon icon={faFilter} />
                        </span>
                        <span>Status</span>
                    </div>
                    {status ? (
                        <button
                            type="button"
                            className="appointment-filter-status__clear"
                            onClick={clearStatusFilter}
                            title="Clear status filter"
                        >
                            <FontAwesomeIcon icon={faArrowsRotate} size="xs" />
                            <span>Clear</span>
                        </button>
                    ) : null}
                </div>
                <p className="appointment-filter-status__hint">
                    Select one status. Click again to show all.
                </p>
                <div
                    className="appointment-filter-status__chips"
                    role="group"
                    aria-label="Filter appointments by status"
                >
                    {STATUS_OPTIONS.map((opt) => (
                        <button
                            key={opt.value}
                            type="button"
                            className={`appointment-filter-status__chip appointment-filter-status__chip--${opt.value}${status === opt.value ? " is-active" : ""}`}
                            onClick={() => handleStatusClick(opt.value)}
                            aria-pressed={status === opt.value}
                        >
                            <span
                                className="appointment-filter-status__dot"
                                aria-hidden="true"
                            />
                            {opt.label}
                        </button>
                    ))}
                </div>
            </div>

            {/* <div className='px-2 date-filter border py-2'>
                <p className='p-0 m-0 title text-center'>Location & Doctor Filter {(selectedLocation?._id || searchParams.get('doctor')) && <FontAwesomeIcon onClick={() => {
                    locationDoctorRestFun()
                }
                } size='xs' className='ml-1 rest' icon={faArrowsRotate} />}</p>
                <hr className='m-0 p-0 mb-2'></hr>
                <div onClick={() => { setLocationRest(false) }}>
                    <small>Location</small>
                    <SelectWithLocalSearch currentValue={currentLocation} reset={locationRest} name="location" handleFormValues={handleSubmitLocation} isCreatable={false} options={allLocations} placeHolder='Select location'></SelectWithLocalSearch>
                </div>
                <div>
                    <small>Doctor</small>
                    <SelectWithLocalSearch currentValue={currentDoctor} isDisabled={selectedLocation?.doctors?.length ? false : true} name="doctor" handleFormValues={handleLocationDoctor} isCreatable={false} options={selectedLocation?.doctors || []} placeHolder='Select doctor'></SelectWithLocalSearch>

                </div>
            </div> */}
        </div>
    )
}
export default AppointmentFilter

